require("!!D:\\project-water\\water\\node_modules\\script-loader\\addScript.js")(require("!!D:\\project-water\\water\\node_modules\\raw-loader\\index.js!D:\\project-water\\water\\node_modules\\babel-loader\\lib\\index.js!D:\\project-water\\water\\src\\vendor\\Blob.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./src/vendor/Blob.js
// module id = FZkK
// module chunks = 1